import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz12 = () => {
    return (
        <div>
               <NavLink to='/category/Puzzels/Puzzel13'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel11'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Maximize probability of White Ball</h1>
    
    <div class="text">
        <p>There are two empty bowls in a room. You have 50 white balls and 50 black balls. After you place the balls in
            the bowls, a random ball will be picked from a random bowl. Distribute the balls (all of them) into the
            bowls to maximize the chance of picking a white ball.</p>
        <p>&nbsp;<br/>
        &nbsp;<br/>
        &nbsp;</p>
        <div class="containers">
        <p><strong>Explanation:</strong><br/>
        First, let us assume that we divided the balls into jars equally so each jar
            will contain 50 balls.<br/>
            So the probability of selecting a white ball will be=probability of selecting the
            first jar*probability of white ball in the first jar + probability of selecting the second jar*probability
            of white ball in the second jar<br/>
            =(1/2)*(0/50)+(1/2)*(50/50)=0.5<br/>
            Since we have to maximize the
            probability so we will increase the probability of white ball in the first jar and keep the second
            probability same mean equal to 1<br/>
            so we add 49 white balls with 50 black balls in the first jar and only
            one white ball in the second jar<br/>
            so the probability will be now=</p>
        <pre>(1/2)*(49/99)+(1/2)*(1/1)=0.747</pre>
        <p>Therefore, probability of getting white ball becomes 1/2*1 + 1/2*49/99 which is approximately 3/4.</p>
        </div>
    </div>
</article>
        </div>
    )
}

export default Puz12
